import React from 'react';
import "./categoryItem.scss";

const CategoryItem = (props) => {

    return (
        <div onClick={() => {props.onClickCategory(props.data.id, props.data.description)}} className={props.isGalleryMode ? "gallery-category-item" :"category-item"} style={{ backgroundImage: `url("${props.data.image}")` }}>
            <div className="inner" ><span>{props.data.description}</span></div>
        </div>
    );
}
export default CategoryItem;


